import { IconProps } from '.';

const FilterIcon = ({
  color = 'var(--color-sage-300)',
  customClasses,
  ...rest
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="2em"
      viewBox="0 0 18 15"
      fill="none"
      className={customClasses}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.75 3C4.75 2.30964 5.30964 1.75 6 1.75C6.69036 1.75 7.25 2.30964 7.25 3C7.25 3.69036 6.69036 4.25 6 4.25C5.30964 4.25 4.75 3.69036 4.75 3ZM3.35352 3.75H0V2.25H3.35352C3.67998 1.09575 4.74122 0.25 6 0.25C7.25878 0.25 8.32002 1.09575 8.64648 2.25H18V3.75H8.64648C8.32002 4.90425 7.25878 5.75 6 5.75C4.74122 5.75 3.67998 4.90425 3.35352 3.75ZM13.25 12C13.25 12.6904 12.6904 13.25 12 13.25C11.3096 13.25 10.75 12.6904 10.75 12C10.75 11.3096 11.3096 10.75 12 10.75C12.6904 10.75 13.25 11.3096 13.25 12ZM12 14.75C13.2588 14.75 14.32 13.9043 14.6465 12.75H18V11.25H14.6465C14.32 10.0957 13.2588 9.25 12 9.25C10.7412 9.25 9.67998 10.0957 9.35352 11.25L0 11.25V12.75L9.35352 12.75C9.67998 13.9043 10.7412 14.75 12 14.75Z"
        fill={color}
      />
    </svg>
  );
};

export default FilterIcon;
